export enum Steps {
  nameAndDescription = 'name_and_description',
  privacyAndReminders = 'privacy_and_reminders',
}

export type Goal = {
  description: string;
  name: string;
  icon: string;
  date: string;
  assigneeId: number;
  privacy: string;
  reminder: string;
};

export enum PrivacyType {
  justMe = 'just_me',
  meAndATeammate = 'me_and_a_teammate',
  meAndChoosenTeammate = 'me_and',
  groupWorkspace = 'a_group',
  everyone = 'everyone',
}

export enum ReminderType {
  daily = 'daily',
  onceAWeek = 'once_a_week',
  everyOtherWeek = 'every_other_week',
  onceAMonth = 'once_a_month',
  never = 'never',
}
